const availableStates = [
  {
    state: 'Acre',
    code: 'AC',
  },
  {
    state: 'Alagoas',
    code: 'AL',
  },
  {
    state: 'Amapá',
    code: 'AP',
  },
  {
    state: 'Amazonas',
    code: 'AM',
  },
  {
    state: 'Bahia',
    code: 'BA',
  },
  {
    state: 'Ceará',
    code: 'CE',
  },
  {
    state: 'Distrito Federal',
    code: 'DF',
  },
  {
    state: 'Espírito Santo',
    code: 'ES',
  },
  {
    state: 'Goiás',
    code: 'GO',
  },
  {
    state: 'Maranhão',
    code: 'MA',
  },
  {
    state: 'Mato Grosso',
    code: 'MT',
  },
  {
    state: 'Mato Grosso do Sul',
    code: 'MS',
  },
  {
    state: 'Minas Gerais',
    code: 'MG',
  },
  {
    state: 'Pará',
    code: 'PA',
  },
  {
    state: 'Paraíba',
    code: 'PB',
  },
  {
    state: 'Paraná',
    code: 'PR',
  },
  {
    state: 'Pernambuco',
    code: 'PE',
  },
  {
    state: 'Piauí',
    code: 'PI',
  },
  {
    state: 'Rio de Janeiro',
    code: 'RJ',
  },
  {
    state: 'Rio Grande do Norte',
    code: 'RN',
  },
  {
    state: 'Rio Grande do Sul',
    code: 'RS',
  },
  {
    state: 'Rondônia',
    code: 'RO',
  },
  {
    state: 'Roraima',
    code: 'RR',
  },
  {
    state: 'Santa Catarina',
    code: 'SC',
  },
  {
    state: 'São Paulo',
    code: 'SP',
  },
  {
    state: 'Sergipe',
    code: 'SE',
  },
  {
    state: 'Tocantins',
    code: 'TO',
  },
]

export default availableStates
